/* Ginspire Wellness — theme.js (header, drawers, sticky bar, quiz, misc) */
(function () {
  // Mobile menu
  const menu = document.getElementById('MenuDrawer');
  document.querySelectorAll('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { menu.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }));
  document.querySelectorAll('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { menu.removeAttribute('open'); document.body.style.overflow = ''; }));

  // Sticky add-to-cart bar on product pages
  const sticky = document.querySelector('.sticky-bar');
  const buyBox = document.querySelector('[data-buy-box]');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0));
    }, { threshold: 0 });
    io.observe(buyBox);
    const stickyBtn = sticky.querySelector('[data-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', () => {
      const form = document.querySelector('form[data-product-form]');
      if (form) form.requestSubmit();
    });
  }

  // Quantity steppers (generic)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    let val = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Quiz
  const quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    const steps = Array.from(quiz.querySelectorAll('.quiz__step'));
    const result = quiz.querySelector('.quiz__result');
    const progress = quiz.querySelector('.quiz__progress span');
    const answers = {};
    let i = 0;
    function show(n) {
      steps.forEach((s, idx) => { if (idx === n) s.setAttribute('data-active', ''); else s.removeAttribute('data-active'); });
      if (progress) progress.style.width = Math.round((n / steps.length) * 100) + '%';
    }
    quiz.querySelectorAll('.quiz__option').forEach((opt) => {
      opt.addEventListener('click', () => {
        const step = opt.closest('.quiz__step');
        answers[step.getAttribute('data-key')] = opt.getAttribute('data-value');
        i += 1;
        if (i < steps.length) { show(i); return; }
        steps.forEach((s) => s.removeAttribute('data-active'));
        if (progress) progress.style.width = '100%';
        renderResult();
      });
    });
    function renderResult() {
      const goal = answers.goal || 'energy';
      const skin = answers.skin || 'no';
      const time = answers.time || 'morning';
      const map = quiz.getAttribute('data-results');
      let picks = [];
      try { picks = JSON.parse(map)[goal] || []; } catch (e) {}
      if (skin === 'yes') picks = picks.concat(time === 'night' ? ['night-repair-balm'] : ['morning-glow-balm']);
      const list = result.querySelector('[data-quiz-picks]');
      list.innerHTML = '';
      picks.slice(0, 3).forEach((handle) => {
        const tpl = quiz.querySelector('[data-quiz-card="' + handle + '"]');
        if (tpl) list.appendChild(tpl.content.cloneNode(true));
      });
      result.setAttribute('data-active', '');
      const endpoint = quiz.getAttribute('data-lead-endpoint');
      const email = result.querySelector('form[data-quiz-lead]');
      if (email && endpoint) {
        email.addEventListener('submit', (ev) => {
          ev.preventDefault();
          const fd = new FormData(email);
          fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: fd.get('email'), answers, picks, source: 'ginspirewellness.com' }) }).catch(() => {});
          email.innerHTML = '<p class="form__success">Got it. Your code is on its way.</p>';
        });
      }
    }
    show(0);
  }
})();
